import { Injectable } from '@angular/core';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class SbPageTitleStrategy extends TitleStrategy {
  private defaultTitle = 'seatback adplacer';

  constructor(
    private readonly title: Title,
    private readonly translate: TranslateService
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      this.title.setTitle(`${this.translate.instant(title)} - ${this.defaultTitle}`);
    }
  }

  public setDefaultTitle(title: string) {
    if (title) {
      this.defaultTitle = title;
    }
  }
}
